import PreorderEventList from '../preorderEvent/PreorderEventList';

const PreorderEvents = () => {
  return (
    <div>
      <PreorderEventList />
    </div>
  )
}

export default PreorderEvents;